'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('reservation-overview', {
      url: '/reservation/overview',
      template: '<reservation-overview></reservation-overview>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/reservation/overview/reservation-overview.routes.js